import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("perla_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Admin impersonation: quando presente, tutte le API "shared" (mio-giorno,
  // contratti, rubrica) operano nel workspace del venditore selezionato.
  try {
    const imp = sessionStorage.getItem("perla.impersonatingSalesRep");
    if (imp) {
      const p = JSON.parse(imp);
      if (p?.id) config.headers["X-Sales-Rep-Id"] = p.id;
    }
  } catch (e) {}
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem("perla_token");
    }
    return Promise.reject(err);
  }
);
